'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductDownloadAttachment } from './product-download-attachment';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const ProductAttachment = ({ product }: { product: ProductDetailData }) => {
  const { t } = useTranslations();

  return (
    <Accordion type="single" collapsible className="w-full border-none p-0">
      <AccordionItem value="attachment" className="w-full p-0">
      <AccordionTrigger
          className={cn(
            'w-full p-0 no-underline hover:no-underline',
            'ea-product-detail__accordion-trigger',
          )}
        >
          <h3
            className={cn(
              'font-heading uppercase',
              'text-xl font-medium text-foreground lg:text-2xl',
            )}
          >
            {t('text333')}
          </h3>
        </AccordionTrigger>
        <AccordionContent className="items-starts flex w-full flex-col justify-start gap-6 p-0 pt-6">
          <ProductDownloadAttachment attachments={product.attachments as any} />
          <Separator orientation="horizontal" className="bg-[#E5E5E5]" />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
